import React, { createContext, useState, useContext } from "react";

const MonacoStatusContext = createContext();

export const MonacoStatusProvider = ({ children }) => {
  const [monacoStatus, setMonacoStatus] = useState("loading Monaco Editor...");

  const value = { monacoStatus, setMonacoStatus };

  return (
    <MonacoStatusContext.Provider value={value}>
      {children}
    </MonacoStatusContext.Provider>
  );
};

export const useMonacoStatus = () => {
  const context = useContext(MonacoStatusContext);
  if (!context) {
    throw new Error(
      "useMonacoStatus must be used within a MonacoStatusProvider"
    );
  }
  return context;
};
